/**
 * Social Proof Order Stats Component
 * Handles interactions and animations for the product order statistics
 */

class ProductOrderStats extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Add fade-in animation when element becomes visible
    this.observeVisibility();
    
    // Add hover effects
    this.addHoverEffects();
  }

  observeVisibility() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    observer.observe(this);
  }

  addHoverEffects() {
    this.addEventListener('mouseenter', () => {
      this.classList.add('is-hovered');
    });

    this.addEventListener('mouseleave', () => {
      this.classList.remove('is-hovered');
    });
  }
}

// Register the custom element
if (customElements && !customElements.get('product-order-stats')) {
  customElements.define('product-order-stats', ProductOrderStats);
}

// Initialize existing elements on page load
document.addEventListener('DOMContentLoaded', () => {
  const existingElements = document.querySelectorAll('product-order-stats:not(:defined)');
  existingElements.forEach(element => {
    if (!element.hasAttribute('data-initialized')) {
      element.setAttribute('data-initialized', 'true');
      new ProductOrderStats();
    }
  });
});
 